/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconAnvil: {
  name: 'anvil';
  data: string;
} = {
  name: 'anvil',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M505.25 284.137c29.653-9.455 59.306-30.542 88.959-61.112-29.677-31.115-58.672-46.438-88.959-52.204v-43.347H143.699v31.48H21.955c21.948 59.552 70.094 100.604 121.744 114.654v51.345h95.208c-16.524 56.145-50.795 102.233-92.702 142.123H110.23v31.491l-.466.38h.466v42.575H560.5v-74.446h-47.872c-46.818-39.849-80.018-85.896-95.47-142.123h88.092v-40.816z"/></svg>`,
};
